export class IdentityUserDto {
Id: string;
Discriminator: string;
PasswordHash: string;
SecurityStamp: string;
SubscriberId: string;
Email: string;
PhoneNo: string;
UserType: string;
StaffId: string;
SubscriberName: string;
FirstName: string;
LastName: string;
MiddleName: string;
StaffName: string;
Logo: string;
VerifyStatus: string;
IsConfirmed: string;
UIN: string;
NewUser: string;
UserName: string;
StaffRole_RoleId: string;
SiteId: string;

dateJoined?: Date;

}
